import { describeShape, isTruncatedShape, safeParseJson, summarizeIssues } from '@shared/parse-json';
import { StreamMessageSchema, type StreamMessage } from '../types/stream-protocol';
import { logger } from './logger';

export function parseStreamFrame(text: string, source: string): StreamMessage | null {
  const parsed = safeParseJson(StreamMessageSchema, text);
  if (parsed.success) return parsed.data;
  const shapes = summarizeIssues(parsed.error.issues);
  const first = shapes[0];
  // Built from safe metadata only (kind, code, schema path): the raw parse-error text can quote the frame,
  // and the frame's own `type` is attacker/data-controlled, so it is not logged either.
  const where = first && !isTruncatedShape(first) ? `: ${describeShape(first)}` : '';
  logger.warn(
    { kind: parsed.error.kind, issues: shapes },
    `[stream-frame] dropped frame in ${source} (${parsed.error.kind}${where})`,
  );
  return null;
}
